<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="chaptertitle1">Contents</h2>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/ack">Acknowledgments</a></p>
<p class="toc2"><a href="#/intro">Introduction: The Qualities of Color and Concrete</a></p>
<p class="toc1"><span href="#/chap1" title="Link target outside of Sample"><b>1</b>   Normal Life in the Former Socialist City</span></p>
<p class="toc1"><span href="#/chap2" title="Link target outside of Sample"><b>2</b>   Socialist Realism in the Socialist City</span></p>
<p class="toc1"><span href="#/chap3" title="Link target outside of Sample"><b>3</b>   Socialist Modern and the Production of Demanding Citizens</span></p>
<p class="toc1"><span href="#/chap4" title="Link target outside of Sample"><b>4</b>   Socialist Generic and the Branding of State Socialism</span></p>
<p class="toc1"><span href="#/chap5" title="Link target outside of Sample"><b>5</b>   Organicist Modern and Super-Natural Organicism</span></p>
<p class="toc1"><span href="#/chap6" title="Link target outside of Sample"><b>6</b>   Unstable Landscapes of Property, Morality, and Status</span></p>
<p class="toc1"><span href="#/chap7" title="Link target outside of Sample"><b>7</b>   The New Family House and the New Middle Class</span></p>
<p class="toc1"><span href="#/chap8" title="Link target outside of Sample"><b>8</b>   Heterotopias of the Normal in Private Worlds</span></p>
<p class="toc2"><span href="#/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc2"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?105e5fce